import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  useSpring, useTrail, useChain, animated, config,
} from 'react-spring';
import MenusContext from './menus-context';

export default function ExpandableMenu(props) {
  const { state, dispatch } = React.useContext(MenusContext);
  const { text, action } = props;
  const [expanded, setExpanded] = React.useState(false);
  const fadeRef = React.useRef();
  const spring = useSpring({
    opacity: expanded ? 1 : 0,
    config: config.slow,
    ref: fadeRef,
  });
  const trailRef = React.useRef();
  const trail = useTrail(action.length, {
    opacity: 1,
    tranform: 'translateY(-50%)',
    config: config.slow,
    ref: trailRef,
  });

  useChain([fadeRef, trailRef]);

  React.useEffect(() => {
    if (state.expandedMenu && (state.expandedMenu !== text)) {
      setExpanded(false);
    }
  }, [state.expandedMenu, text]);

  function onToggleExpandable(e) {
    e.preventDefault();
    setExpanded(!expanded);
    dispatch({ type: 'setExpandedMenu', payload: text });
  }

  return (
    <React.Fragment>
      <a href="#" onClick={onToggleExpandable} className={classNames({ expanded })}>
        <span className="menu">{text}</span>
        <span className="arrow">◢</span>
      </a>
      {expanded && (
        <animated.ul style={spring}>
          {trail.map((style, index) => {
            const { text: t, anchor } = action[index];
            return (
              <animated.li key={t} style={style}><a {...anchor}>{t}</a></animated.li>
            );
          })}
        </animated.ul>
      )}
    </React.Fragment>
  );
}

const anchorPropType = PropTypes.exact({
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  'data-method': PropTypes.string,
  onClick: PropTypes.func,
});

ExpandableMenu.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.arrayOf(PropTypes.exact({
    text: PropTypes.string.isRequired,
    anchor: anchorPropType.isRequired,
  })).isRequired,
};
